function parseHostname(options) {
    var _a;
    var hostname = options.hostname;
    // 解析用户提供的 hostname
    if (hostname) {
        if (hostname.indexOf('//') !== -1) {
            _a = hostname.split('//'), hostname = _a[1];
        }
        if (hostname.indexOf('/') !== -1) {
            hostname = hostname.split('/')[0];
        }
        if (hostname.indexOf(':') !== -1) {
            hostname = hostname.split(':')[0];
        }
    }
    else {
        hostname = window.location.hostname;
    }
    return hostname && hostname.trim();
}
function parseCurrentScriptSrc(options) {
    var currentScriptSrc = options.currentScriptSrc;
    if (currentScriptSrc) {
        return currentScriptSrc;
    }
    if (window.__CURRENT_SCRIPT_SRC__) {
        currentScriptSrc = window.__CURRENT_SCRIPT_SRC__;
    }
    else if (window.__current_micro_config__ &&
        window.__current_micro_config__.prefix) {
        currentScriptSrc = window.__current_micro_config__.prefix;
    }
    else if (window.document.currentScript) {
        var script = window.document.currentScript;
        currentScriptSrc = script.src;
    }
    return currentScriptSrc && currentScriptSrc.trim();
}
var regIp = /^\d+\.\d+\.\d+\.\d+$/;
export function getCnEnv(options) {
    if (options === void 0) { options = {}; }
    try {
        // case: 读取外界注入的 window.__CN_ENV__, 优先级最高, 这样也可以在本地 public/index.html 模拟其他环境
        if (typeof window !== 'undefined' && window.__CN_ENV__) {
            return window.__CN_ENV__;
        }
        // case: 线上代码代理到本地调试
        if (process.env.NODE_ENV === 'development') {
            return 'daily';
        }
        var hostname = parseHostname(options);
        if (!hostname) {
            return 'prod';
        }
        // case: localhost/127.0.0.1
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return 'daily';
        }
        // case: ip 30.117.72.7
        if (regIp.test(hostname)) {
            return 'daily';
        }
        var parts = hostname.split('.');
        var head = parts[0] || '';
        var tail = parts[parts.length - 1] || '';
        // case: pre.xxx pre-xxx.yyy pre2-xxx.yyy
        if (head === 'pre' ||
            head.indexOf('pre-') === 0 ||
            head.indexOf('pre2-') === 0) {
            return 'pre';
        }
        // case: daily.xxx daily-xxx.yyy
        if (head === 'daily' || head.indexOf('daily-') === 0) {
            return 'daily';
        }
        // case: xxx.test
        if (tail === 'test') {
            return 'daily';
        }
        // case: xxx.net
        if (tail === 'net') {
            return 'daily';
        }
        // case: currentScriptSrc
        var currentScriptSrc = parseCurrentScriptSrc(options);
        if (!currentScriptSrc) {
            return 'prod';
        }
        if (currentScriptSrc.indexOf('https://g.alicdn.com') === 0) {
            return 'prod';
        }
        if (currentScriptSrc.indexOf('https://dev.g.alicdn.com') === 0) {
            return 'daily';
        }
    }
    catch (err) {
        // ignore err
    }
    return 'prod';
}
export * from './types';
